<p-panel header="{{'pages_titles.users.list' | translate}}">
<app-loader *ngIf="loadingSpinner"></app-loader>


    <ng-template pTemplate="icons">
        <button *ngIf="!noDataFound" pButton class="p-panel-header-icon p-link" (click)="exportAsXLSX()">
            <span class="pi pi-download"></span>
        </button>
    </ng-template>

    <div *ngIf="noDataFound && !loadingSpinner" class="text-center">
        <img src="assets/images/empty-data.png" class="responsive-image" alt="empty-data-image" />
        <p class="no-data-found w-100">{{'userListVide' | translate}}</p>
        <button pButton class="mt-3"  icon="pi pi-user-plus" iconPos="left" (click)="goAddEmployee()"
         type="button" label="{{'pages_titles.add.employee' | translate}}" ></button>
    </div>

    <div *ngIf="!noDataFound && !loadingSpinner" class="space cardBodyLayout">
        <form class="w-100 center search-table-outter" [formGroup]="getFiltersForm">

            <input pInputText (ngModelChange)="paginateChange($event);onFilterChange()" class="search-global"
                placeholder="{{'Start_recherche'| translate}}" type="text" name="searchTextUsername"
                formControlName="searchTextUsername" />

            <table class="table-form" #dataTable="mfDataTable" [mfData]="employeesCustomer" #mf="mfDataTable" [mfRowsOnPage]="10">

                <thead class="thead-form">
                    <tr>
                        <th scope="col"> {{'Actions' | translate}}</th>
                        <th scope="col">
                            <mfDefaultSorter by="username">{{'Username' | translate}}</mfDefaultSorter>
                        </th>
                        <th scope="col">
                            <mfDefaultSorter by="email">{{'Email' | translate}}</mfDefaultSorter>
                        </th>
                        <th scope="col">
                            <mfDefaultSorter by="fullName">{{'name' | translate}}</mfDefaultSorter>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="not-display"></tr>
                    <tr class="not-display">
                        <td></td>
                        <td>
                            <div>
                                <span class="p-input-icon-left">
                                    <i class="pi pi-search"></i>
                                    <input pInputText (ngModelChange)="paginateChange($event);onFilterChange()"
                                        placeholder="{{'Start_recherche'| translate}}" type="text"
                                        name="searchTextUsername" formControlName="searchTextUsername" class="w-100" />
                                </span>
                            </div>
                        </td>

                        <td>
                            <div>
                                <span class="p-input-icon-left">
                                    <i class="pi pi-search"></i>
                                    <input pInputText (ngModelChange)="paginateChange($event);onFilterChange()"
                                        placeholder="{{'Start_recherche'| translate}}" type="text"
                                        name="searchTextEmail" formControlName="searchTextEmail" class="w-100" />
                                </span>
                            </div>
                        </td>

                        <td>
                            <div>
                                <span class="p-input-icon-left">
                                    <i class="pi pi-search"></i>
                                    <input pInputText (ngModelChange)="paginateChange($event);onFilterChange()"
                                        placeholder="{{'Start_recherche'| translate}}" type="text" name="searchTextNom"
                                        formControlName="searchTextNom" class="w-100" />
                                </span>
                            </div>
                        </td>
                    </tr>
                    <tr *ngFor="let employeesCustomer of mf.data ; index as i">
                        <td attr.data-label="{{'Actions' | translate}}" class="slot fix-col-table">
                            <div>
                                <i class="pi pi-pencil text-primary" (click)="navigateEdit(employeesCustomer._id)"
                                    pTooltip="{{'tooltip.user_update' | translate}} " tooltipPosition="bottom"></i>
                                <i class="fa fa-user-secret text-primary mr-3"
                                    (click)="openDialog(employeesCustomer, 'anonym')"
                                    pTooltip="{{'tooltip.user_anonym' | translate}}" tooltipPosition="bottom"></i>
                                <i class="fas fa-charging-station text-primary"
                                    (click)="openDialog(employeesCustomer, 'sessions')"
                                    pTooltip="{{'tooltip.user_session_show' | translate}}" tooltipPosition="bottom"></i>
                                <i class="pi pi-eye text-primary" (click)="openDialog(employeesCustomer, 'details')"
                                    pTooltip="{{'tooltip.user_show' | translate}}" tooltipPosition="bottom"></i>
                                <i class="pi pi-trash text-danger" (click)="openDialog(employeesCustomer, 'delete')"
                                    pTooltip="{{'tooltip.user_delete' | translate}}" tooltipPosition="bottom"></i>
                            </div>
                        </td>
                        <td attr.data-label="{{'Username' | translate}}">
                            <p class="text-center overflow-auto"><strong>{{employeesCustomer.username}}</strong></p>
                        </td>
                        <td attr.data-label="{{'Email' | translate}}">
                            <p class="text-center overflow-auto">{{employeesCustomer.email}}</p>
                        </td>
                        <td attr.data-label="{{'name' | translate}}">
                            <p class="text-center overflow-auto">{{employeesCustomer.fullName}}</p>
                        </td>
                    </tr>

                </tbody>
                <tfoot>
                    <tr>
                        <td colspan="4">
                            <mfBootstrapPaginator #Paginator [rowsOnPageSet]="[10,25,50,75]"></mfBootstrapPaginator>
                        </td>
                    </tr>
                </tfoot>
            </table>

            <div *ngIf="noDataSearch && !noDataFound" class="no-data-search">
                <img src="assets/images/empty-data.png" class="responsive-image" alt="empty-data-image" />
                <p class="no-data-found w-100">{{'NO_DATA_SEARCH' | translate}}</p>
            </div>
        </form>
    </div>

</p-panel>

<p-dialog header="{{'details' | translate}}" [(visible)]="displayDetailsModal" [modal]="true" [style]="{width: '50vw'}"
    [draggable]="false" [resizable]="false">

    <div *ngIf="user?.photo" class="row">
        <img class="center-img" src="{{user?.photo}}"
            width="100" height="100" />
    </div>
    <div class="mb-4 text-center">
        <h2 class="text-capitalize">
            {{user ? user.username : '--'}}
        </h2>
    </div>

    <div class="row">
        <div class="col-md-6">
            <label>{{'Type' | translate}} :</label>
        </div>
        <div class="col-md-6">
            <p (ngModel)="user.type">{{(user?.type) ? (user?.type) : '--'}}</p>
        </div>
    </div>
    <div *ngIf="user?.firstName" class="row">
        <div class="col-md-6">
            <label>{{'First_name' | translate}} :</label>
        </div>
        <div class="col-md-6">
            <p (ngModel)="user.firstName">{{user?.firstName}}
            </p>
        </div>
    </div>

    <div  *ngIf="user?.lastName" class="row">
        <div class="col-md-6">
            <label>{{'Last_name' | translate}} :</label>
        </div>
        <div class="col-md-6">
            <p (ngModel)="user.lastName">{{(user?.lastName) ? (user?.lastName) : '--'}}</p>
        </div>
    </div>

    <div *ngIf="user?.username" class="row">
        <div class="col-md-6">
            <label>{{'Username' | translate}} :</label>
        </div>
        <div class="col-md-6">
            <p (ngModel)="user.username">{{(user?.username) ? (user?.username) : '--'}}</p>
        </div>
    </div>

    <div *ngIf="user?.email" class="row">
        <div class="col-md-6">
            <label>{{'Email' | translate}} :</label>
        </div>
        <div class="col-md-6">
            <p (ngModel)="user.email">{{(user?.email) ? (user?.email) : '--'}}</p>
        </div>
    </div>

    <div *ngIf="user?.gender" class="row">
        <div class="col-md-6">
            <label>{{'Gender' | translate}} :</label>
        </div>
        <div class="col-md-6">
            <p (ngModel)="user.gender">{{(user?.gender) ? (user?.gender) : '--'}}</p>
        </div>
    </div>

    <div *ngIf="user?.birthdate" class="row">
        <div class="col-md-6">
            <label>{{'Birthdate' | translate}} :</label>
        </div>
        <div class="col-md-6">
            <p (ngModel)="user.birthdate ">
                {{user?.birthdate? (user?.birthdate | date: 'MMMM d, y') : '--'}}
            </p>
        </div>
    </div>

    <div *ngIf="user?.address" class="row">
        <div class="col-md-6">
            <label>{{'Address' | translate}} :</label>
        </div>
        <div class="col-md-6">
            <p (ngModel)="user.address ">{{user?.address ? (user?.address) : '--'}}</p>
        </div>
    </div>

    <div *ngIf="user?.phoneNumber" class="row">
        <div class="col-md-6">
            <label>{{'Phone' | translate}} :</label>
        </div>
        <div class="col-md-6">
            <p (ngModel)="user.phoneNumber ">
                {{user?.phoneNumber? (user?.phoneNumber) : '--'}}
            </p>
        </div>
    </div>
</p-dialog>

<p-dialog header=' {{ "pages_titles.list-sessions" | translate }}' [(visible)]="displaySessionsModal" [modal]="true"
    [style]="{width: '70vw'}" [draggable]="false" [resizable]="false">
    <app-loader *ngIf="loadingSpinnerSessions"></app-loader>
    <div *ngIf="!noDataFoundSessions !loadingSpinnerSessions">
        <div class="search-table-outter ">
            <table class="table-form" #dataTable="mfDataTable" [mfData]="chargingSessions" #mf="mfDataTable"
                [mfRowsOnPage]="3">
                <thead class="thead-form">
                    <tr>
                        <th style=" width: 300px !important; ">
                            <mfDefaultSorter by="location.name">{{'station_name' | translate}}
                            </mfDefaultSorter>
                        </th>
                        <th>
                            <mfDefaultSorter by="rfid">{{'Badge' | translate}}</mfDefaultSorter>
                        </th>
                        <th>
                            <mfDefaultSorter by="statusTr">{{'status' | translate}}</mfDefaultSorter>
                        </th>
                        <th style=" width: 250px !important; ">
                            <mfDefaultSorter by="energyConsumed">{{'Energy_consumed' | translate}}(kwh)
                            </mfDefaultSorter>
                        </th>
                        <th>
                            <mfDefaultSorter by="duration">{{'Charging_time' | translate}}
                            </mfDefaultSorter>
                        </th>
                        <th style=" width: 200px !important; ">
                            <mfDefaultSorter by="cpoTariffCoef">{{'CPO_coefficient' | translate}}
                            </mfDefaultSorter>
                        </th>
                        <th style=" width: 250px !important; ">
                            <mfDefaultSorter by="intermediationFees">{{'intermediationFees' | translate}} (€)
                            </mfDefaultSorter>
                        </th>
                        <th>
                            <mfDefaultSorter by="operatingFees">{{'operatingFees' | translate}} (€)
                            </mfDefaultSorter>
                        </th>
                        <th>
                            <mfDefaultSorter by="cost">{{'Price' | translate}} EMSP (€)
                            </mfDefaultSorter>
                        </th>
                        <th>
                            <mfDefaultSorter by="startDate">{{'beginTime' | translate}}
                            </mfDefaultSorter>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr></tr>
                    <tr *ngFor="let charingS of mf.data ; index as i">
                        <td>
                            <p class="text-center overflow-auto">{{charingS.location?.name}}</p>
                        </td>
                        <td>
                            <p class="text-center overflow-auto">
                                {{charingS.rfid}}
                            </p>
                        </td>
                        <td>
                            <div>
                                <strong *ngIf="charingS.status === 'COMPLETED'"
                                    class="badge badge-primary text-white text-undefined text-alignment-center text-transform-none paragraph">
                                    {{ charingS.statusTr }}
                                </strong>
                            </div>
                            <strong *ngIf="charingS.status === 'ACTIVE'"
                                class="badge badge-success text-white text-undefined text-alignment-center text-transform-none paragraph">
                                {{ charingS.statusTr }}
                            </strong>
                        </td>
                        <td>
                            <p class="text-center overflow-auto">{{charingS.energyConsumed}}</p>
                        </td>
                        <td>
                            <p class="text-center overflow-auto">{{charingS.duration}}</p>
                        </td>
                        <td>
                            <p class="text-center overflow-auto">{{charingS.cpoTariffCoef}}</p>
                        </td>
                        <td>
                            <p class="text-center overflow-auto">{{charingS.intermediationFees}}</p>
                        </td>
                        <td>
                            <p class="text-center overflow-auto">{{charingS.operatingFees}}</p>
                        </td>
                        <td>
                            <p class="text-center overflow-auto">{{charingS.cost}}</p>
                        </td>
                        <td>
                            <p class="text-center overflow-auto">{{charingS.startDate}}</p>
                        </td>


                    </tr>
                </tbody>
                <tfoot>
                    <tr>
                        <td colspan="10">
                            <mfBootstrapPaginator #Paginator  [rowsOnPageSet]="[3, 10,25,50,75]">
                            </mfBootstrapPaginator>
                        </td>
                    </tr>
                </tfoot>

                <!-- No data alert -->

            </table>
        </div>
    </div>
    <div *ngIf="noDataFoundSessions" class="no-data-search">
        <img src="assets/images/empty-data.png" class="responsive-image" alt="empty-data-image" />
        <p class="no-data-found w-100">{{'noDataFound' | translate}}</p>
    </div>

</p-dialog>

<p-dialog position="bottom" header="{{'make-user-anonym' | translate}}" [(visible)]="displayAnonymModal" [modal]="true"
    [style]="{width: '50vw'}" [draggable]="false" [resizable]="false">
    {{'Confirm_anonym' | translate}} {{ user?.username }} {{'Anonymous' | translate}} ?
    <ng-template pTemplate="footer">
        <p-button icon="pi pi-check" (click)="displayAnonymModal=false;anonymEmployee()"
            label="{{'actions.make-anonym' | translate}}" styleClass="p-button-primary"></p-button>
    </ng-template>
</p-dialog>

<p-dialog position="bottom" header="{{'Delete' | translate}}" [(visible)]="displayDeleteModal" [modal]="true"
    [style]="{width: '50vw'}" [draggable]="false" [resizable]="false">
    {{'Confirm_delete' | translate}}
    <strong>{{ user?.username }} </strong> ?
    <ng-template pTemplate="footer">
        <p-button icon="pi pi-check" (click)="displayDeleteModal=false;deleteUser()"
            label=" {{'actions.delete' | translate}}" styleClass="p-button-danger"></p-button>
    </ng-template>
</p-dialog>